<script>
    import {LOG_MESSAGE_TYPE} from "../../../../../lib/datatypes";
    import {toDate, now, getTimeDiffAsDaysAgo} from "../../../../../lib/dates_times";

    export let log;
    export let is_last = false;
</script>

<li>
    <div class="relative pb-8">
        {#if !is_last}
        <span class="absolute top-4 left-4 -ml-px h-full w-0.5 bg-gray-200" aria-hidden="true"></span>
        {/if}
        <div class="relative flex space-x-3">
            <div>
                {#if log.type === LOG_MESSAGE_TYPE.OBJECT_CREATED}
                    <!-- Blue Thumbs-Up -->
                    <span class="h-8 w-8 rounded-full bg-blue-500 flex items-center justify-center ring-8 ring-white">
                        <svg class="h-5 w-5 text-white" x-description="Heroicon name: mini/hand-thumb-up" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                            <path d="M1 8.25a1.25 1.25 0 112.5 0v7.5a1.25 1.25 0 11-2.5 0v-7.5zM11 3V1.7c0-.268.14-.526.395-.607A2 2 0 0114 3c0 .995-.182 1.948-.514 2.826-.204.54.166 1.174.744 1.174h2.52c1.243 0 2.261 1.01 2.146 2.247a23.864 23.864 0 01-1.341 5.974C17.153 16.323 16.072 17 14.9 17h-3.192a3 3 0 01-1.341-.317l-2.734-1.366A3 3 0 006.292 15H5V8h.963c.685 0 1.258-.483 1.612-1.068a4.011 4.011 0 012.166-1.73c.432-.143.853-.386 1.011-.814.16-.432.248-.9.248-1.388z"></path>
                        </svg>
                    </span>
                {:else if log.type === LOG_MESSAGE_TYPE.ACTION_COMPLETED}
                    <!-- Green Tick -->
                    <span class="h-8 w-8 rounded-full bg-green-500 flex items-center justify-center ring-8 ring-white">
                        <svg class="h-5 w-5 text-white" x-description="Heroicon name: mini/check" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                            <path fill-rule="evenodd" d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z" clip-rule="evenodd"></path>
                        </svg>
                    </span>
                {:else if log.type === LOG_MESSAGE_TYPE.USER_ENTRY}
                    <!-- Grey User -->
                    <span class="h-8 w-8 rounded-full bg-gray-400 flex items-center justify-center ring-8 ring-white">
                        <svg class="h-5 w-5 text-white" x-description="Heroicon name: mini/user" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                            <path d="M10 8a3 3 0 100-6 3 3 0 000 6zM3.465 14.493a1.23 1.23 0 00.41 1.412A9.957 9.957 0 0010 18c2.31 0 4.438-.784 6.131-2.1.43-.333.604-.903.408-1.41a7.002 7.002 0 00-13.074.003z"></path>
                        </svg>
                    </span>
                {:else if log.type === LOG_MESSAGE_TYPE.CONTACTED}
                    <span class="h-8 w-8 rounded-full bg-purple-500 flex items-center justify-center ring-8 ring-white">
                        <svg class="h-5 w-5 text-white" x-description="Heroicon name: outline/chat-bubble-bottom-center-text" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M7.5 8.25h9m-9 3H12m-9.75 1.51c0 1.6 1.123 2.994 2.707 3.227 1.129.166 2.27.293 3.423.379.35.026.67.21.865.501L12 21l2.755-4.133a1.14 1.14 0 01.865-.501 48.172 48.172 0 003.423-.379c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z" />
                        </svg>
                    </span>
                {/if}

            </div>

            <div class="flex min-w-0 flex-1 justify-between space-x-4 pt-1.5">
                <div>

                    {#if log.type === LOG_MESSAGE_TYPE.OBJECT_CREATED}
                        <p class="text-sm text-gray-500">Created</p>
                    {:else if log.type === LOG_MESSAGE_TYPE.ACTION_COMPLETED}
                        <p class="text-sm text-gray-500"><em class="font-medium text-gray-900">Completed {log.data.waiting_for ? 'Waiting For' : 'Action'}:</em> {@html log.data.details}</p>
                    {:else if log.type === LOG_MESSAGE_TYPE.USER_ENTRY}
                        <p class="text-sm text-gray-500"><em class="font-medium text-gray-900">User Event:</em> {@html log.data}</p>
                    {:else if log.type === LOG_MESSAGE_TYPE.CONTACTED}
                        <p class="text-sm text-gray-500"><em class="font-medium text-gray-900">Contacted:</em>TODO refine these details</p>
                    {/if}

                </div>
                <div class="whitespace-nowrap text-right text-sm text-gray-500">
                    <time datetime="{log.created}" title="{log.created}">{getTimeDiffAsDaysAgo(now().valueOf() - toDate(log.created))}</time>
                </div>
            </div>
        </div>
    </div>
</li>

<style></style>